<app-sidebar></app-sidebar>
<main class="dashboard-main">
  <div class="dashboard-content">
    <div class="dashboard-header" style="display:flex; align-items:center; justify-content:space-between;">
      <div>
        <h1 class="dashboard-title">Distributors</h1>
        <div class="dashboard-welcome">Manage your distribution network</div>
      </div>
      <button *ngIf="userType === 'admin' || userType === 'super_admin' || userType === 'staff'" class="add-btn px-4 py-2 md:px-5 md:py-2.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors cursor-pointer font-medium text-sm md:text-base"
        (click)="openAddModal()">
        Add Distributor
      </button>
    </div>
    <hr>
    <div class="my-6 flex flex-col md:flex-row gap-3">
      <input type="text" placeholder="Search distributors..." [(ngModel)]="searchTerm" #searchBox
        (input)="onSearch(searchBox.value)"
        class="flex-1 md:w-80 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-blue-500" />
    </div>
    <div class="overflow-x-auto md:overflow-x-visible rounded-lg">
    <table class="modern-table min-w-full">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Status</th>
          <th>Retailers</th>
          <th>Revenue</th>
          <th>Joined</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let d of distributors">
          <td>{{d.distributor_name}}</td>
          <td>{{d.email}}</td>
          <td>{{d.phone_number}}</td>
          <td>
            <span class="status" [class]="getDistributorStatusClass(d.status)">
              {{d.status | titlecase}}
            </span>
          </td>
          <td>
            <a href="javascript:void(0)" (click)="openRetailersModal(d)" class="retailer-chip">
              {{d.retailer_count || 0}}
            </a>
          </td>
          <td>{{d.total_revenue ? ('₹' + (d.total_revenue | number:'1.2-2')) : '-'}}</td>
          <td>{{d.created_at | date:'mediumDate'}}</td>
          <td>
            <span class="action-btn"
              *ngIf="userType === 'admin' || userType === 'super_admin' || (userType === 'staff' && d.is_admin_approved === false)"
              (click)="editDistributor(d)" title="Edit">
              <i class="fas fa-edit"></i>
            </span>
            <span class="action-btn bank" (click)="openBankModal(d)" title="Bank Details"
              *ngIf="userType === 'admin' || userType === 'super_admin'">
              <i class="fas fa-university"></i>
            </span>
            <span class="action-btn documents" (click)="openDocumentModal(d)" title="Documents"
              *ngIf="userType === 'admin' || userType === 'super_admin' || userType === 'staff'">
              <i class="fas fa-file-alt"></i>
            </span>
            <span class="action-btn delete" *ngIf="userType === 'admin' || userType === 'super_admin'"
              (click)="deleteDistributor(d)" title="Delete">
              <i class="fas fa-trash"></i>
            </span>
          </td>
        </tr>
        <tr *ngIf="!loading && distributors.length === 0">
          <td colspan="8" style="text-align:center; padding:24px; color:#888;">No data</td>
        </tr>
        <tr *ngIf="loading">
          <td colspan="8" style="text-align:center; padding:24px; color:#888;">Loading...</td>
        </tr>
      </tbody>
    </table>
    </div>
    <div *ngIf="pagination.totalPages > 1" class="mt-6 flex flex-col sm:flex-row justify-center items-center gap-3 flex-wrap">
      <button (click)="goToPage(pagination.page - 1)" [disabled]="!pagination.hasPrev"
        class="px-3 sm:px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">Prev</button>
      <span class="text-sm text-gray-600">Page {{pagination.page}} of {{pagination.totalPages}}</span>
      <button (click)="goToPage(pagination.page + 1)" [disabled]="!pagination.hasNext"
        class="px-3 sm:px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">Next</button>
    </div>
    <app-add-distributor-modal *ngIf="showAddModal" [isEdit]="!!editingDistributorId"
      [distributor]="selectedDistributorData" (close)="closeAddModal()"
      (submitDistributor)="handleAddDistributor($event)">
    </app-add-distributor-modal>

    <app-bank-details-modal *ngIf="showBankModal" [distributorId]="selectedDistributorForBank?.id"
      [distributorName]="selectedDistributorForBank?.distributor_name" (close)="closeBankModal()"
      (saved)="onBankDetailsSaved($event)">
    </app-bank-details-modal>

    <app-linked-retailers-modal *ngIf="showRetailersModal" [distributorId]="selectedDistributorForRetailers?.id"
      [distributorName]="selectedDistributorForRetailers?.distributor_name" (close)="closeRetailersModal()">
    </app-linked-retailers-modal>

    <app-document-modal *ngIf="showDocumentModal" [distributorId]="selectedDistributorForDocuments?.id"
      [distributorName]="selectedDistributorForDocuments?.distributor_name" (close)="closeDocumentModal()"
      (saved)="onDocumentsSaved()">
    </app-document-modal>
  </div>
</main>